<template>
 <div :class="windowClass">
    <v-row no-gutters>
            <v-col xs="12" class="pa-2">
                

                    <v-card class="pa-2">
                        <v-card-title>
                        <v-icon large left color="secondary">mdi-account-tie</v-icon> MANAGE USERS  
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                        ></v-text-field>
                        <v-icon right color="success" class="mt-5 ml-10" large @click="user={}, state='new', form=true">mdi-plus-box</v-icon> 
                        </v-card-title>
                             <v-data-table
                                class="va-table"
                                dense
                                :headers="headers"
                                :search="search"
                                :items="users"
                                >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                        <td>
                                        <v-icon small left color="warning" @click="user=item, state='update', form=true" >mdi-pencil</v-icon>
                                        {{ item.username }}</td>
                                        <td>{{ item.role }}</td>
                                        <td>{{ item.created  | moment("YYYY-MM-DD HH:mm:ss a")}}</td>
                                    </tr>
                                    </tbody>
                                </template>
                                </v-data-table>
                    </v-card>
            </v-col>
    </v-row>
    <va-user-form :show="form" :user="user" :state="state" @DialogEvent="formEvent" />
  </div>
</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
        form: false,
        state: 'new',
        user: {},
        search:'',
        users:[],
        headers: [
            { text: 'User', value:"username"},
            { text: 'Role'},
            { text: 'Registered' }
        ],
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.getItems()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      formEvent(data){
          this.form = false
          if(data.action != 'close') {
              this.user = data.user
              this.Save()
          }
          console.log(data)
      },
      getItems: function() { 
        this.$http.post("user/list", JSON.stringify({})).then(response => {
            response.data.data != null?this.users = response.data.data:this.users =[]
        }).catch(e => {
        console.log(e.data)
        })
     },
      Save: function() {
        let method = 'user/register'
        this.state != 'new'?method='user/update':method = 'user/register'
        this.$http.post(method, JSON.stringify(this.user)).then(response => {
            response.data.status? this.setAlertColor('success'): this.setAlertColor('error')
            this.setAlertText(response.data.message)
            this.setAlert(true)
            this.getItems()
        }).catch(e => {
        console.log(e)
        })
     },
    }
  }
</script>